<div id="section-global-messages" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Global Messages</p>

    <div class="m-t-20">
      <div class="grid m-t--20">
        <div class="custom-col m-t-20">
          <button
            type="button"
            class="btn btn-outline-success w-100"
            (click)="alert('Success Text', GlobalMessageType.MSG_TYPE_CONFIRMATION)"
          >
            Success
          </button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-danger w-100" (click)="alert('Danger Text', GlobalMessageType.MSG_TYPE_ERROR)">
            Danger
          </button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-warning w-100" (click)="alert('Warning Text', GlobalMessageType.MSG_TYPE_WARNING)">
            Warning
          </button>
        </div>

        <div class="custom-col m-t-20">
          <button type="button" class="btn btn-outline-info w-100" (click)="alert('Info Text', GlobalMessageType.MSG_TYPE_INFO)">
            Info
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
